module.exports = __webpack_public_path__ + "videos/mgu-video.39c5346.webm";